import React, { Component } from "react";
import { userDetail } from "../../config/userDetails";
import TabsConstants from "../../constants";
import { isAuthorized } from "../Common/CheckAuthorization";
import MandatoryFields from "../private/MandatoryFields/MandatoryFields";
import SubMenu from "../private/SubMenu";
import BillingView from "./Billing/BillingView";
import DashboardView from "./Dashboard/DashboardView";
import UsersView from "./Users/UsersView";

const CHILD_ROUTES = {
  USERS: "users",
  BILLING: "billing",
  MANDATORYFIELDS: "mandatory-fields"
};

class Settings extends Component {
  state = { activeTabValue: "" };
  componentWillMount() {
    this.setStateBasedOnRoutes(this.props);
  }

  setStateBasedOnRoutes = props => {
    const params = props.route.match.params;
    const segment0 = Object.keys(params).length > 0 ? params["0"] : null;
    const path = this.props.route.match.path;
    this.setState({ children: path });
    if (segment0 && segment0.indexOf(CHILD_ROUTES.MANDATORYFIELDS) !== -1) {
      this.setState({
        activeTabValue: CHILD_ROUTES.MANDATORYFIELDS,
        children: CHILD_ROUTES.MANDATORYFIELDS
      });
    } else if (segment0 && segment0.indexOf(CHILD_ROUTES.BILLING) !== -1) {
      this.setState({
        activeTabValue: CHILD_ROUTES.BILLING,
        children: CHILD_ROUTES.BILLING
      });
    } else {
      this.setState({
        activeTabValue: CHILD_ROUTES.USERS,
        children: CHILD_ROUTES.USERS
      });
    }
  };

  componentWillReceiveProps(props) {
    this.setStateBasedOnRoutes(props);
  }

  render() {
    const { activeTabValue, children } = this.state;
    const { SettingScreen } = TabsConstants;
    const menuName = "Settings";
    return (
      isAuthorized() && (
        <div className="">
          <SubMenu
            menuName={menuName}
            tabsVisible={SettingScreen[userDetail().roleName]}
            routes={this.props.route}
            activeTabValue={activeTabValue}
            handleChangeTabBody={this.updateTabBody}
          />
          {children === CHILD_ROUTES.USERS && <UsersView />}
          {children === CHILD_ROUTES.BILLING && <BillingView />}
          {children === CHILD_ROUTES.MANDATORYFIELDS && <MandatoryFields />}
        </div>
      )
    );
  }
}

export default Settings;



// WEBPACK FOOTER //
// ./src/components/private/Settings.js